import { createI18n } from 'vue-i18n';

const i18n = createI18n({
    legacy: false,
    fallbackLocale: 'en',
    messages: {},
    missing: (locale, key) => {
        if (process.env.NODE_ENV !== 'production') {
            console.warn(
                `Missing translation for key "${key}" in locale "${locale}"`
            );
        }
    },
});

export const setI18nLocale = (locale, messages) => {
    i18n.global.locale.value = locale;
    i18n.global.setLocaleMessage(locale, messages);
};

export default i18n;
